import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotsGrabNarrow = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17 20C17 18.8954 16.1046 18 15 18C13.8954 18 13 18.8954 13 20C13 21.1046 13.8954 22 15 22C16.1046 22 17 21.1046 17 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 29C17 27.8954 16.1046 27 15 27C13.8954 27 13 27.8954 13 29C13 30.1046 13.8954 31 15 31C16.1046 31 17 30.1046 17 29Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 11C17 9.89543 16.1046 9 15 9C13.8954 9 13 9.89543 13 11C13 12.1046 13.8954 13 15 13C16.1046 13 17 12.1046 17 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 20C27 18.8954 26.1046 18 25 18C23.8954 18 23 18.8954 23 20C23 21.1046 23.8954 22 25 22C26.1046 22 27 21.1046 27 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 29C27 27.8954 26.1046 27 25 27C23.8954 27 23 27.8954 23 29C23 30.1046 23.8954 31 25 31C26.1046 31 27 30.1046 27 29Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 11C27 9.89543 26.1046 9 25 9C23.8954 9 23 9.89543 23 11C23 12.1046 23.8954 13 25 13C26.1046 13 27 12.1046 27 11Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDotsGrabNarrow);
export default ForwardRef;
